/* 여행지 추가/수정 */
$(".editDestinationBtn").on("click", function(e){
    e.preventDefault();

    var datas = $(this).data();

    /* 초기화 */
    $("#printImages").html("");
    $("#editDestination_form").each(function(){
        this.reset();
    });
    $("#editDestination_form input[data-role=tagsinput]").tagsinput('removeAll');

    $("#cityList").empty();

    $("#editDestinationTitle").html(datas.title);
    $("#editDestination_form > input[name=_method]").val(datas.method);
    $("#editDestination_form").attr('action', "dests" + ( datas.method == 'PUT' ? "/" + datas.json.id : '' ) );

    $("#editDestination_form input[name=id]").val( undefined != datas.id ? datas.id : '' );

    if( undefined != datas.json ) {

        $("#editDestination_form select[name=type]").val(datas.json.type).prop("selected", true);
        $("#editDestination_form select[name=country]").val(datas.json.country).prop("selected", true);
        $("#editDestination_form select[name=rating]").val(datas.json.rating).prop("selected", true);
        $("#editDestination_form input[name=title]").val(datas.json.title);
        $("#editDestination_form input[name=title_en]").val(datas.json.title_en);
        $("#editDestination_form input[name=addr]").val(datas.json.addr);
        $("#editDestination_form input[name=tel]").val(datas.json.tel);
        $("#editDestination_form input[name=domain]").val(datas.json.domain);
        $("#editDestination_form input[name=location]").val(datas.json.location);
        $("#editDestination_form textarea[name=description]").val(datas.json.description);
        $("#editDestination_form textarea[name=cautions]").val(datas.json.cautions);
        $("#editDestination_form textarea[name=meeting]").val(datas.json.meeting);
        $("#editDestination_form textarea[name=sales]").val(datas.json.sales);
        $("#editDestination_form textarea[name=check]").val(datas.json.check);
        $("#editDestination_form textarea[name=use]").val(datas.json.use);
        $("#editDestination_form textarea[name=canclePolicy]").val(datas.json.canclePolicy);
        $("#editDestination_form textarea[name=watchpoint]").val(datas.json.watchpoint);

        // 지역 세팅
        var citys = $("#editDestination_form select[name=country]").find(':selected').data('citylists').split(',');
        for( const city in citys ){
            citys[city] = citys[city].trim();
            if( citys[city].length ) {
                var cityData = citys[city].split(':');
                $("#cityList").append('<option value="'+cityData[0]+'" data-content="<span class=\'badge badge-success\'>'+cityData[0]+'</span> '+cityData[1]+'"></option>');
            }
        }
        $('#cityList').selectpicker('refresh');
        $("#editDestination_form select[name=city]").val(datas.json.city).prop("selected", true);

        // 키워드 세팅
        var tags = datas.json.tag;
        if( tags ) {
            var tagArray = tags.split(',');
            for (var tag_i in tagArray) {
                $("#editDestination_form input[name=tag]").tagsinput('add', tagArray[tag_i]);
            }
        }

        // 뱃지 세팅
        var badges = datas.json.badge;
        if( badges ) {
            var badgeArray = badges.split(',');
            for (var badge_i in badgeArray) {
                $("#editDestination_form input[name=badge]").tagsinput('add', badgeArray[badge_i]);
            }
        }


        // 이미지 리스트
        var images = JSON.parse(datas.json.images);
        var printImageSource = $("#editDestImages").val();
        var printImagePrint = "";
        for( var image_i in images ) {
            var printImagesTmp = printImageSource;
            printImagesTmp = printImagesTmp.replace(/{--imgid--}/gi, image_i);
            printImagesTmp = printImagesTmp.replace(/{--image--}/gi, "/storage/" + images[image_i]);
            printImagePrint += printImagesTmp;
        }
        $("#printImages").html(printImagePrint);

    }

    $('#editDestination_form .selectpicker').selectpicker('refresh');

    $( "#printImages" ).sortable({
        placeholder: 'sortable_placeholder',
        update: function () {
            var sorted = $( "#printImages" ).sortable( "toArray" );
            $('#sortedImages').val(sorted);
        }
    });

});


/* 여행지 옵션 추가/수정 */
$(".editDestOptionBtn").on("click", function(e) {
    e.preventDefault();

    var datas = $(this).data();

    $("#editDestOptionTitle").html(datas.title);
    $("#editDestOption_form > input[name=_method]").val(datas.method);
    $("#runtimeConv").val( '' );

    $("#editDestOption_form input[name=parent]").val(datas.parent);

    $("#editDestOption_form").attr('action', "destopt" + ( datas.method == 'PUT' ? "/" + datas.json.id : '' ) );

    if( undefined != datas.json ){

        $("#weekBtnGroup > label").removeClass('active');

        var weeks = JSON.parse(datas.json.week);
        for ( week in weeks ){
            $("#weekBtnGroup > label").eq(weeks[week]).addClass('active');
            $("#weekBtnGroup > label > input").eq(weeks[week]).prop('checked',true);
        }

        $("#editDestOption_form input[name=opentime]").val(datas.json.opentime);
        $("#editDestOption_form input[name=closetime]").val(datas.json.closetime);
        $("#editDestOption_form input[name=price]").val(number_format(datas.json.price));
        $("#editDestOption_form select[name=money]").val(datas.json.money).prop("selected", true);
        $("#editDestOption_form input[name=runtime]").val(number_format(datas.json.runtime));
        $("#runtimeConv").val( minToTime($("#runtime").val()) );
        $("#editDestOption_form input[name=infomation]").val(datas.json.infomation);
        $("#editDestOption_form textarea[name=include]").val(datas.json.include);
        $("#editDestOption_form textarea[name=uninclude]").val(datas.json.uninclude);


        $("#editDestOption_form select[name=country]").val(datas.json.country).prop("selected", true);
        $("#editDestOption_form input[name=addr]").val(datas.json.addr);
        $("#editDestOption_form input[name=location]").val(datas.json.location);

    }

    $('#editDestOption_form .selectpicker').selectpicker('refresh');

});



/* 시간 계산 */
$("#runtime").on("keyup", function(e){
    $("#runtimeConv").val( minToTime($(this).val()) );
});

$("#runtimeConv").on("keyup", function(e){
    $("#runtime").val(timeToMin( $(this).val() ));
});


/* 200분 을 03:20 3시간 20분 으로 표시 */
function minToTime( getTime ){
    var runtime = parseInt( getTime.replace(/[^0-9]/g,'') );
    var time = "";
    var hour = parseInt( runtime / 60 );
    time = time + ( hour > 0 ? ( hour >= 10 ? '' : '0' ) + hour : '00' ) + ":";
    var min = parseInt( runtime % 60 );
    time = time + ( min > 0 ? ( min >= 10 ? '' : '0' ) + min : '00' );
    return time;
}


/* 03:20 3시간 20분 을 200분 으로 표시 */
function timeToMin( getTime ){
    var runtime = getTime.split(":");
    var hour = parseInt( runtime[0] );
    var min = parseInt( runtime[1] );
    var time = 0;
    if( hour > 0 ) {
        time = time + hour * 60;
    }
    if( min > 0 ) {
        time = time + min;
    }
    return time;
}